import Vue from 'vue';

export const OPEN_HANDLER = 'open_handler';

export const eventHub = new Vue({});
